module.exports = {
  "id": "collectible",
  "title": "Collectible",
  "color": "red",
  "info": [
    {
      "text": "Make this piece disappear when touched by another piece",
      "image": "provision/glitches/collectible/collectible.gif"
    }
  ],
  "icon": "pacman",
  "category": "destroy",
  "searchTags": ["coin","get","gather","disappear"],
  "exposedVariables": [
    {
      "tooltip":"Set which piece can collect this piece",
      "value": "none",
      "variableName": "collector piece",
      "spriteName": "$glitch_target",
      "input": {
        "type": "sprite"
      }
    }
  ],
  "codeImage": "provision/glitches/collectible/collectible.png",
  "code": null,
  "zip": null,
  "sb3": null
};